

export const mockFormState = {
  kennitala: "1404542739",
  nafn: "Ásgeir Þórhallsson",
  heimili: "Álfatröð 3B",
  sveitarfelagsnumer: "7620",
  numerKjordaemis: 5,
  kjorstadurNumer: 1,
  kjordeild: 1,
  atkvaediTegundId: 1,
  kosningId: 77,
  athugasemd: "Mock athugasemd",
  adstodKjorstjori: true,
  adstodFulltrui: false,
  adstodBlindur: true,
  adstodHond: false,
  vottord: true
};

export const mockKjosandi = {
  oid: 4075389,
  kosning: 77,
  kennitala: "1234567890",
  nafn: "Svampur Sveinsson",
  kyn: "1",
  rikisfang: "IS",
  loghHusk: "762031932532    ",
  husheiti: "Sjóbotnsgata 3B",
  postnr: "600",
  tegundKjosanda: "AlmennirKjosendur",
  numerKjordaemis: 5,
  kjordaemi: "Norðausturkjördæmi                       ",
  sveitarfelagsnumer: "7620",
  sveitarfelag: "Sjóhérað",
  kjorstadurNumer: 1,
  kjorstadur: "Menntaskólinn á Egilsstöðum",
  kjordeild: 1,
  faedingardagur: "1967-04-14T00:00:00",
  dagsetningAfrits: "2019-05-09T12:04:37.667",
  husheitiRodun: "Sjóbotnsgata",
  husNrRodun: "0032",
  rodunarkodi: 51114,
  radnumer: 39320067,
  nafnRadad: "Svampur Sveinsson"
};

export const mockActiveKosning = {
  id: 77,
  lysing: "Sveitarstjórnarkosningar 2022",
  tegund: 2,
  tegundLysing: "Sveitarstjórnarkosninga",
  kosningadagur: "2019-06-08T00:00:00",
  kjorskrardagur: "2019-04-20T00:00:00",
  kosningaaldur: 18
};